export default __webpack_public_path__ + "static/media/marine.40e1639a.jpg";